import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";

const PHONE = "919057862163";
const MSG = encodeURIComponent("Hello CRETRE Team, I would like to discuss my manpower/recruitment requirement.");

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${PHONE}?text=${MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 active:scale-95 transition-transform"
    >
      <WhatsappLogo size={30} weight="fill" />
    </a>
  );
}
